const euro = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatEuro(value: number | null | undefined): string {
  if (value === null || value === undefined) return "Onbekend";
  return euro.format(value);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "Onbekend";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Onbekend";
  return new Intl.DateTimeFormat("nl-NL", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Europe/Amsterdam",
  }).format(date);
}

export function formatRating(value: number | null | undefined): string {
  if (value === null || value === undefined) return "Geen beoordeling";
  return value.toFixed(1).replace(".", ",");
}

/** Records ouder dan 30 dagen vragen om een nieuwe controle. */
export function needsRecheck(value: string | null | undefined): boolean {
  if (!value) return true;
  const date = new Date(value).getTime();
  if (Number.isNaN(date)) return true;
  return Date.now() - date > 30 * 24 * 60 * 60 * 1000;
}

export function speedLabel(hours: number | null | undefined): string {
  if (hours === null || hours === undefined) return "Onbekend";
  if (hours <= 1) return "Direct";
  if (hours <= 24) return "Binnen 24 uur";
  if (hours <= 72) return "1-3 werkdagen";
  return "3+ werkdagen";
}
